// extracted by mini-css-extract-plugin
export default {"suggestion":"P3Gw_D","link":"nBUPcz"};